import React from 'react'
import { connect } from 'react-redux'
import AdvancedTable from '../../Components/AdvancedTable'
import SchedulerActions from '../../Redux/SchedulerRedux'
import ProductActions from '../../Redux/ProductRedux'
import BannerActions from '../../Redux/BannerRedux'
import Select from 'react-select'
import Modal from 'react-responsive-modal'
import { fauxCreate, fauxUpdate, fauxDelete } from '../../Utils/FauxArrayUtils'
import FormatMoney from '../../Utils/FormatMoney'

class ModularScheduler extends React.Component {
  constructor (props) {
    super(props)
    this.preserveArray = props.detail.items
    this.state = {
      showModal: null,
      editMode: null,
      modemPicker: [],
      bannerPicker: [],
      selectedModem: {
        value: '',
        label: ''
      },
      selectedBanner: {
        value: '',
        label: ''
      },
      id: props.detail.id,
      newArray: [{
        status: '',
        value: '',
        name: '',
        id: ''
      }],
      form: {
        product: props.detail.product,
        date: props.detail.date,
        items: props.detail.items
      },
      extraDetails: ''
    }
  }

  componentDidMount = () => {
    this._fetchSchedulerDetails()
    this._determineGetter(this.props.type)
  }

  _fetchSchedulerDetails = () => {
    let data = { id: this.state.id }
    this.props.getSchedulerDetail(data)
  }

  _determineGetter = (type) => {
    switch (type) {
      case 'modems':
        this.props.getProductCustom()
        break
      case 'banners':
        this.props.bannerCustomRequest()
        break
      case 'attractions':
      default:
        return null
    }
  }

  componentDidUpdate = (prevProps) => {
    const { product, banner, type } = this.props
    if (type === 'modems') {
      if (product !== prevProps.product) {
        if (product.custom !== null && product.custom.length > 0) {
          this._populateModemPicker(product.custom)
        }
      }
    } else if (type === 'banners') {
      if (banner !== prevProps.banner) {
        if (banner.custom !== null && banner.custom.length > 0) {
          this._populateBannerPicker(banner.custom)
        }
      }
    }
  }

  _populateModemPicker = (custom) => {
    let modemPicker = []
    custom.map((item, i) => (
      modemPicker[i] = {
        value: item.id,
        label: item.title,
        name: item.title,
        status: item.status
      }
    ))
    this.setState({ modemPicker })
  }

  _populateBannerPicker = (custom) => {
    let bannerPicker = []
    custom.map((item, i) => (
      // array1[i] = {
      bannerPicker[i] = {
        value: item.id,
        label: item.title,
        name: item.title,
        status: item.status
      }
    ))
    this.setState({ bannerPicker })
  }

  _determineProductType = (type) => {
    switch (type) {
      case 'modems':
        return 'Wifi Product'
      case 'banners':
        return 'Banner'
      case 'attractions':
        return 'Attraction'
      default:
        return null
    }
  }

  _toggleModal = (showModal, reset) => {
    this.setState({ showModal })
    if (reset) {
      let form = { ...this.state.form }
      form.items = this.preserveArray
      this.setState({ form, extraDetails: '', editMode: null })
    }
  }

  _selectChange = (method, selected) => {
    let newArray = this.state.newArray
    newArray[0].id = selected.value
    newArray[0].name = selected.name
    if (method === 'modems') {
      this.setState({ selectedModem: selected, newArray })
    } else if (method === 'banners') {
      this.setState({ selectedBanner: selected, newArray })
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let newArray = this.state.newArray
    newArray[0][field] = value
    this.setState({ newArray })
  }

  _editItem = (editMode, item, type) => {
    let newArray = this.state.newArray
    if (item) {
      newArray[0].status = item.status
      newArray[0].value = item.value
      newArray[0].name = item.name
      newArray[0].id = item.id
      if (type === 'modems') {
        this.setState({ selectedModem: { value: item.id, label: item.name } })
      } else if (type === 'banners') {
        this.setState({ selectedBanner: { value: item.id, label: item.name } })
      }
      this.setState({ newArray })
    } else if (!item) {
      newArray[0].status = ''
      newArray[0].value = ''
      newArray[0].name = ''
      newArray[0].id = ''
      this.setState({
        selectedModem: { value: '', label: '' },
        selectedBanner: { value: '', label: '' },
        newArray
      })
    }
    this.setState({ editMode })
  }

  _prepareFauxDelete = (item) => {
    let form = { ...this.state.form }
    form.items = fauxDelete(this.state.form.items, item.id)
    this.setState({ form, extraDetails: item.name })
    this._toggleModal('delete')
  }

  _prepareFauxPut = (event) => {
    event && event.preventDefault()
    let form = { ...this.state.form }
    if (this.state.editMode) {
      form.items = fauxUpdate(this.state.form.items, this.state.newArray, this.state.newArray[0].id)
    } else {
      form.items = fauxCreate(this.state.form.items, this.state.newArray)
    }
    this.setState({ form, extraDetails: this.state.newArray[0].name })
    this._toggleModal('confirmation')
  }

  _finalizeSubmit = () => {
    let data = {
      id: this.state.id,
      form: this.state.form
    }
    this.props.putScheduler(data)
    this._toggleModal(null, false)
    this._editItem(null)
  }

  _renderForm = (type) => {
    switch (type) {
      case 'modems':
        return (
          <form onSubmit={(event) => this._prepareFauxPut(event)}>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Product</label>
              </div>
              <div className='col-9'>
                <Select
                  placeholder='Select Wifi Product To Add ...'
                  isDisabled={this.state.editMode !== null}
                  isOptionDisabled={option => option.isDisabled}
                  options={this.state.modemPicker}
                  value={this.state.selectedModem}
                  onChange={(selectedModem) => this._selectChange('modems', selectedModem)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Status</label>
              </div>
              <div className='col-9'>
                <select className='form-control' value={this.state.newArray[0].status} required onChange={(event) => this._inputChange(event, 'status')}>
                  <option disabled value=''>--Select Status--</option>
                  <option value='active'>Active</option>
                  <option value='inactive'>Inactive</option>
                </select>
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Price</label>
              </div>
              <div className='col-9'>
                <input required value={this.state.newArray[0].value} min={1} type='number' className='form-control' onChange={(event) => this._inputChange(event, 'value')} />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-12 text-right'>
                {
                  this.state.editMode !== null && <button onClick={() => this._editItem(null)} className='btn btn-secondary mr-2'><i className='fa fa-times' /> Cancel</button>
                }
                {
                  this.state.editMode === null
                    ? <button className='btn btn-primary' type='submit'>
                      <i className='fa fa-plus' /> Add
                    </button>
                    : <button className='btn btn-primary' type='submit'>
                      <i className='fa fa-save' /> Save
                    </button>
                }
              </div>
            </div>
          </form>
        )
      case 'banners':
        return (
          <form onSubmit={(event) => this._prepareFauxPut(event)}>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Banner</label>
              </div>
              <div className='col-9'>
                <Select
                  placeholder='Select Banner To Add ...'
                  isDisabled={this.state.editMode !== null}
                  options={this.state.bannerPicker}
                  value={this.state.selectedBanner}
                  onChange={(selectedBanner) => this._selectChange('banners', selectedBanner)}
                />
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Status</label>
              </div>
              <div className='col-9'>
                <select className='form-control' value={this.state.newArray[0].status} required onChange={(event) => this._inputChange(event, 'status')}>
                  <option disabled value=''>--Select Status--</option>
                  <option value='active'>Active</option>
                  <option value='inactive'>Inactive</option>
                </select>
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Priority</label>
              </div>
              <div className='col-9'>
                <input required value={this.state.newArray[0].value} type='number' className='form-control' onChange={(event) => this._inputChange(event, 'value')} />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-12 text-right'>
                {
                  this.state.editMode !== null && <button onClick={() => this._editItem(null)} className='btn btn-secondary mr-2'><i className='fa fa-times' /> Cancel</button>
                }
                {
                  this.state.editMode === null
                    ? <button className='btn btn-primary' type='submit'>
                      <i className='fa fa-plus' /> Add
                    </button>
                    : <button className='btn btn-primary' type='submit'>
                      <i className='fa fa-save' /> Save
                    </button>
                }
              </div>
            </div>
          </form>
        )
      case 'attractions':
      default:
        return null
    }
  }

  _renderTable = (detail, type) => {
    return (
      <AdvancedTable
        colSpan={5}
        header={[
          { field: 'Name' },
          { field: 'Status' },
          { field: type === 'modems' ? 'Price' : 'Priority' },
          { field: 'Edit' },
          { field: 'Delete' }
        ]}
        body={
          detail.items &&
          detail.items.length > 0 &&
          detail.items.map(item => ([
            { field: item.name },
            { field: item.status },
            { field: type === 'modems' ? FormatMoney(item.value) : item.value },
            {
              field: <button disabled={this.state.editMode !== null} className='btn btn-primary' onClick={() => this._editItem('update', item, this.props.type)}>
                <i className='fa fa-edit' />
              </button>
            },
            {
              field: <button disabled={this.state.editMode !== null} className='btn btn-danger' onClick={() => this._prepareFauxDelete(item)}>
                <i className='fa fa-trash' />
              </button>
            }
          ]))
        }
      />
    )
  }

  render () {
    const { scheduler, type } = this.props
    return (
      <section className='section' style={{ width: '50vw' }}>
        <header className='title-block mb-3'>
          <h1 className='title'>
            { this._determineProductType(this.props.type) } Scheduler
            <small className='ml-2'>for {this.props.detail.title}</small>
            {
              (scheduler.fetching || scheduler.processing) &&
              <div className='badge badge-info ml-2'>{scheduler.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h1>
        </header>

        { scheduler.err && <div className='alert alert-danger'>{scheduler.err}</div> }

        { this._renderForm(type) }

        { this._renderTable(scheduler.detail, type) }

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'confirmation'} onClose={() => this._toggleModal(null, true)}>
          <section className='section' style={{ width: '45vw' }}>
            <header className='title-block'>
              <h1 className='title'>Confirm {this.state.editMode === null ? 'Add Item' : 'Edit Item'}</h1>
            </header>
            <div className='text-center'>
              <h4>{this.state.extraDetails}</h4>
            </div>
            <div className='row mt-3 mb-3'>
              <div className='col-12 text-right'>
                <button className='btn-secondary btn mr-2' onClick={() => this._toggleModal(null, true)}>Cancel</button>
                <button onClick={() => this._finalizeSubmit()} type='button' className='btn-primary btn'><i className='fa fa-save' />Confirm</button>
              </div>
            </div>
          </section>
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'delete'} onClose={() => this._toggleModal(null, true)}>
          <section className='section' style={{ width: '45vw' }}>
            <header className='title-block'>
              <h1 className='title'>Confirm Delete Item</h1>
            </header>
            <div className='text-center'>
              <h4>{this.state.extraDetails}</h4>
            </div>
            <div className='row mt-3 mb-3'>
              <div className='col-12 text-right'>
                <button className='btn-secondary btn mr-2' onClick={() => this._toggleModal(null, true)}>Cancel</button>
                <button onClick={() => this._finalizeSubmit()} type='button' className='btn-danger btn'><i className='fa fa-trash' />Confirm</button>
              </div>
            </div>
          </section>
        </Modal>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  scheduler: state.scheduler,
  product: state.product,
  banner: state.banner
})

const dispatchToProps = (dispatch) => ({
  getProductCustom: () => dispatch(ProductActions.getProductCustomRequest()),
  bannerCustomRequest: () => dispatch(BannerActions.bannerCustomRequest()),
  getSchedulerDetail: (data) => dispatch(SchedulerActions.getSchedulerDetailRequest(data)),
  putScheduler: (data) => dispatch(SchedulerActions.putSchedulerRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ModularScheduler)



// WEBPACK FOOTER //
// ./src/Containers/Scheduler/ModularScheduler.js